/* Raaga policy pages.
   Scroll-spy only. The table of contents, its links, the size-chart tabs and
   the unit toggle all work with this file absent — nothing here is load-bearing. */
(function () {
  'use strict';

  function init() {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-rgp-toc]'));
    if (!links.length || !('IntersectionObserver' in window)) return;

    var byId = {};
    var targets = [];

    links.forEach(function (a) {
      var id = a.getAttribute('href');
      if (!id || id.charAt(0) !== '#') return;
      var el = document.getElementById(id.slice(1));
      if (!el) return;
      byId[el.id] = a;
      targets.push(el);
    });
    if (!targets.length) return;

    var visible = {};

    function paint() {
      var top = null;
      targets.forEach(function (el) {
        if (!visible[el.id]) return;
        if (top === null || el.getBoundingClientRect().top < top.getBoundingClientRect().top) {
          top = el;
        }
      });
      links.forEach(function (a) { a.classList.remove('is-on'); });
      if (top && byId[top.id]) byId[top.id].classList.add('is-on');
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) { visible[e.target.id] = e.isIntersecting; });
        paint();
      },
      { rootMargin: '-25% 0px -60% 0px', threshold: 0 }
    );

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
